export const SET_MESSAGE = "SET_MESSAGE";

export function setMessage(messageData) {
    return {
        type: SET_MESSAGE,
        payload: messageData,
    };
}
